module.exports = __webpack_public_path__ + "csk-2006eda3fd20430a746b.png";